import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { Background } from './Background';
import { FADE, MAX_LEADERS } from '../../HOME/const';
import * as f from '../logic';
import LeaderItem from '../../HOME/COMPONENTS/LeaderItem';
import { SM_BACKGROUND, SM_GOLD } from '../const';
import { setUserId, showLeaderboards } from '../../HOME/REDUX/actions';
import LeaderBase from '../../HOME/COMPONENTS/LeaderBase';
import BackButton from './BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { getDate, scrollClass } from '../../HOME/utils';
import _ from 'lodash';

class Leaderboard extends LeaderBase {
  state = {
    ...this.state,
    mode: this.props.mode,
    size: this.props.size,
    score: this.props.stats ? this.props.stats.grade : 0,
  };

  componentDidMount() {
    this.init(this.handleSelection);
  }

  getQuery = () => {
    const { size } = this.state;

    return this.leaders
      .where('size', '==', size)
      .orderBy('score', 'desc')
      .orderBy('plays', 'desc')
      .limit(MAX_LEADERS);
  };

  cacheKey(size) {
    size = size || this.state.size;

    return `${this.props.app} LEADERS • ${size}`;
  }

  userKey(id, size) {
    id = id || this.props.uid;
    size = size || this.state.size;

    return `${size} • ${id}`;
  }

  handleSelection = size => {
    size = size || this.state.size;

    this.setState({ size }, () => {
      this.getCachedLeaders(true);

      f.getStats({ size }, stats => {
        const { grade, plays } = f.getMoreStats(stats, size);
        this.setState({ score: grade, plays }, this.updateRanks);
      });
    });
  };

  dataToSubmit = () => {
    const { size, score, plays } = this.state;
    return { size, name: this.state.name.trim(), score, plays, date: getDate() };
  };

  renderNavigation = () => (
    <>
      <BackButton />
      <HomeButton />
    </>
  );

  render() {
    const background = SM_BACKGROUND;
    const rankColor = SM_GOLD;
    const submitColor = 'rgb(70,57,37)';
    const scoreAlias = 'Grade';

    return (
      <>
        <div className={`leaders-screen ${this.props.showLeaders === FADE ? 'fadeout' : ''}`}>
          {this.renderClickableScreen()}
          <div className="leaders fadein-fast" style={{ background, backgroundImage: Background, color: 'white' }}>
            <div className="leaders-selector">
              {_.map([1, 2, 3, 4, 5], size => {
                const current = size === this.state.size;
                const sizeName = f.sizeInfo(size).name;
                const cls = `leaders-circle sm-leaders-size-selector leaders-selector-item ${current ? 'leaders-selector-item-current' : ''}`;
                return (
                  <div key={size} className={cls} style={{ margin: '0 0.5em' }} onClick={() => this.handleSelection(size)}>
                    {sizeName}
                  </div>
                );
              })}
            </div>
            <div className={scrollClass} style={{ gridArea: '2/1', display: 'initial' }}>
              {_.map(this.state.users, (u, i) => (
                <LeaderItem key={i} rank={i + 1} data={u.data} rankColor={rankColor} scoreAlias={scoreAlias} />
              ))}
            </div>
            {this.renderCommon(rankColor, submitColor, scoreAlias)}
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps({ sm, common }) {
  return { ...sm, ...common };
}

export default connect(
  mapStateToProps,
  { setUserId, showLeaderboards }
)(Leaderboard);
